// extracted by mini-css-extract-plugin
module.exports = {"appMenu":"style_appMenu__3Z1vr","active":"style_active__2Ptes"};